export const siteURL = 'https://api.regnumshop.rs';
export const baseURL = `${siteURL}/api`;
export const baseApiUrl = `${siteURL}/api/v1/`;
export const storageURL = `${siteURL}/storage/`;